import { render, staticRenderFns } from "./SelectRider.vue?vue&type=template&id=3205752a&scoped=true"
import script from "./SelectRider.vue?vue&type=script&lang=js"
export * from "./SelectRider.vue?vue&type=script&lang=js"
import style0 from "./SelectRider.vue?vue&type=style&index=0&id=3205752a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3205752a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3205752a')) {
      api.createRecord('3205752a', component.options)
    } else {
      api.reload('3205752a', component.options)
    }
    module.hot.accept("./SelectRider.vue?vue&type=template&id=3205752a&scoped=true", function () {
      api.rerender('3205752a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryOrder/SelectRider.vue"
export default component.exports